<template>
  <div id="app"
    @mousemove.prevent="mouseMove">
    <router-view :init="init"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data () {
    return {
      userInfos: {
            iD: '',
            name: '匿名者',
            type: '',
            status: '4',
            loginTime: new Date(),
            isInit: false
            },
      pageInfo: null,
      idleTime: 0,
      timer: null,
      init: false
    }
  },
  computed: {
    ...mapGetters('system', {
      sysId: 'getSysId'
    }),
    ...mapGetters([
      'getLoading',
      'getUser'
    ]),
    setting () {
      return this.$store.getters.getSetting
    }
  },
  methods: {
    mouseMove(event) {
      //console.log('======mouseMove=====')
      this.idleTime = 0;
    },
    fetchEventsList: function() {
      if (this.$store.state.user.isInit) {
        var interval = 60;
        if (this.setting != null) {
          var num = parseInt(this.setting.idleInterval[0].codeName)
          if (num > 0) {
            interval = num;
          }
        }
            
        this.idleTime++;
        if (this.idleTime > interval) {
          this.$alert(this.setting.idleMessage[0].codeName, '請注意', {
	          confirmButtonText: this.$t('message.Confirm_txt'),
	          callback: action => {
            }
          });
          
          var user = {
            id1: this.$store.state.user.id,
            id2: '',
            id3: '',
            isLogin: false
          }
          var vm = this
          this.$http.put('./WebApi/Common/Authorized', user)
            .then((response) => {
              if (response.data != null) {
                console.log('logout' + user.id)
                //vm.$router.push({ path: '/main' });
              }
            })
            .catch(function (error) {
              //vm.$message.error('對不起,網路連線失敗' + error)
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            })
            vm.$store.dispatch('resetLogin');
            vm.init = !vm.init;
            vm.idleTime = 0;
        }
      }
    }
  },
  mounted () {
    console.log('======created=====')
    this.timer = setInterval(this.fetchEventsList, 60000)
  },
  beforeDestroy() {
    if (this.timer != null) {    
      clearInterval(this.timer)  
    }
  }
}
</script>

<style>
@import './assets/styles/ncut_front.css';
#app {
  font-family: -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif; 
  font-size: 1rem; 
  font-weight: 400; 
  line-height: 1.5;
  margin:0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue